import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/shared/lib/cn";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-semibold leading-tight",
  {
    variants: {
      variant: {
        default: "border-white/15 bg-white/10 text-foreground",
        purple: "border-purple/35 bg-purple/12 text-purple",
        cyan: "border-cyan/35 bg-cyan/12 text-cyan",
        pink: "border-pink/35 bg-pink/12 text-pink",
        amber: "border-amber/35 bg-amber/12 text-amber",
        green: "border-green/35 bg-green/12 text-green",
        muted: "border-white/10 bg-white/5 text-muted-foreground",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps): JSX.Element {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
